import { render, staticRenderFns } from "./PayPro.vue?vue&type=template&id=3f654e28&scoped=true"
import script from "./PayPro.vue?vue&type=script&lang=js"
export * from "./PayPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f654e28",
  null
  
)

export default component.exports